import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AnnouncementBar from "../components/AnnouncementBar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { heroImage, oneWomanImage, oneDesignImage } from "../mock";

const useReveal = () => {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
};

const Home = () => {
  useReveal();
  const heroRef = useRef(null);

  return (
    <>
      <AnnouncementBar />
      <Header />

      {/* Hero */}
      <section className="hero" ref={heroRef}>
        <div className="hero-media" style={{ backgroundImage: `url(${heroImage})` }} />
        <div className="hero-content">
          <h1 className="hero-title">The Art of One.</h1>
          <p className="hero-subtitle">One woman. One design. Made once. Never repeated.</p>
          <Link to="/pages/about" className="btn-primary">Learn More</Link>
        </div>
      </section>

      {/* The One Woman */}
      <section className="split-section">
        <div className="split-image reveal" style={{ backgroundImage: `url(${oneWomanImage})` }} />
        <div className="split-content reveal">
          <div className="section-line" />
          <h2 className="section-title">The “One Woman”</h2>
          <p className="section-text">
            She moves beyond that which wealth may purchase or fame has borrowed. She desires what no woman has yet worn—a gown that begins with her, and ends with her alone.
          </p>
          <p className="section-text">
            She possesses the eye of a collector and the imagination to envision a gown long before its first thread. With her, the language is never one of trends, but of memory, of meaning, and of the singular works she will one day wear. This is how Label Binduu Jain creates.
          </p>
          <p className="section-text" style={{ marginBottom: 34 }}>
            If you recognise yourself here, welcome. You have been searching for us.
          </p>
          <div>
            <Link to="/pages/waitlist-registration" className="btn-primary">Register Your Interest</Link>
          </div>
        </div>
      </section>

      {/* One Design */}
      <section className="split-section reverse">
        <div className="split-image reveal" style={{ backgroundImage: `url(${oneDesignImage})` }} />
        <div className="split-content reveal">
          <div className="section-line" />
          <h2 className="section-title">One Design.</h2>
          <p className="section-text">
            Somewhere within your story lives a gown no one has yet imagined. A colour you loved at seven. A moment that changed the shape of you. A memory you have never worn.
          </p>
          <p className="section-text">
            Bring us that. Not a photograph—yourself. What we return is unmistakable: no one forgets the woman who arrives entirely as her own.
          </p>
        </div>
      </section>

      {/* Made Once. Never Repeated. */}
      <section className="centered-section reveal">
        <div className="centered-line" />
        <h2 className="section-title" style={{ textAlign: "center" }}>Made Once. Never Repeated.</h2>
        <p className="centered-text">
          A vow honoured for every woman we have dressed. And one day, for you.
        </p>
        <p className="centered-text" style={{ maxWidth: 640, margin: "0 auto 22px" }}>
          Every Label Binduu Jain creation is wrought entirely by hand—months of devotion, dozens of artisan hands, techniques centuries old and still living within our atelier. A single embroidery swatch may take weeks to perfect. We consider that reasonable.
        </p>
        <p className="centered-text" style={{ marginBottom: 40 }}>
          And when it is complete, it is complete forever. Never repeated.
        </p>
        <Link to="/pages/waitlist-registration" className="btn-primary">Register Your Interest</Link>
      </section>

      <Footer />
    </>
  );
};

export default Home;
